import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowDownCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowDownCircle"><Path d="M12 21.5C6.75329 21.5 2.5 17.2467 2.5 12C2.5 6.75329 6.75329 2.5 12 2.5C17.2467 2.5 21.5 6.75329 21.5 12C21.5 17.2467 17.2467 21.5 12 21.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M15.5 13L12 16.5L8.5 13" stroke="currentColor" strokeLinecap="square"/><Path d="M12 7.5V16" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowDownCircle;
